import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Warm up the font hosts before React renders so the display typeface is
// available on the first paint (no visible font swap on the headline).
const preconnect = (href: string, crossOrigin?: boolean) => {
  if (document.head.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = href;
  if (crossOrigin) link.crossOrigin = "";
  document.head.appendChild(link);
};
preconnect("https://fonts.googleapis.com");
preconnect("https://fonts.gstatic.com", true);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-443" data-mp="2p1uzeqt718qn" />);
}